import React, { useEffect, useState } from 'react'
import PubSub from 'services/PubSub/'
import Drawer from 'components/Drawers/Drawer'
import { actionsType } from 'config/constants'
import PaymentMethodPrime from './PaymentMethodPrime'
import StorageService from 'services/StorageService'
import PrimeService from 'services/Prime';
import UserInfoService from "services/AccountInfo/";
import { formatRut } from 'utils';
import Day from 'dayjs';
import style from './style.scss'

let actions = []

const DrawerPaymentMethodPrime = () => {
    const [payload, setPayload] = useState(null);

    const callbackSuccessUpdate = (card) => {

        return PrimeService.updatePayMethod(card).then(()=> {
            setTimeout(() => {
                PubSub.dispatch('drawer_payment_method_prime_close')
            }, 500)
        })
    }

    const callbackSuccessRenovation = (card) => {
        return PrimeService.updatePayMethod(card).then(() => {
            return PrimeService.toggleSuscription(true).then((response) => {
                if(!response || response.statusCode !== 200) return false;

                PubSub.dispatch(actionsType.DRAWER.PAYMENT_METHOD_PRIME_CLOSE);
                PubSub.dispatch('update_page_subscription');
                setTimeout(() => {
                    PubSub.dispatch(actionsType.DRAWER.WELCOME_PRIME_OPEN)
                }, 300)
            })
        })
    }

    const callbackGoBackRegister = () => {
        setTimeout(()=> {
            PubSub.dispatch(actionsType.DRAWER.REGISTER_PRIME_OPEN)
        },200)
    }
    const _successRegister = (body) => {
        let data = StorageService.getSecureItem('userData');
        if(body?.birthDate) data.birthDate = body.birthDate;
        if(body?.phone) data.homePhone = body.phone;
        data.CencoPrime_2020 = true;
        return PrimeService.primeDate().then(result => {
            data.prime_invitation_date = result.date;
            StorageService.setSecureItem('userData', data);
            setTimeout(() => {
                PubSub.dispatch(actionsType.DRAWER.PAYMENT_METHOD_PRIME_CLOSE)
                StorageService.removeSecureItem('register_prime_data')
            },1)
            setTimeout(() => {
                PubSub.dispatch('reload_prime');
                PubSub.dispatch(actionsType.DRAWER.WELCOME_PRIME_OPEN)
            }, 300);
        })
    }

    const callbackSuccessRegister = (card) => {
        const {firstName, lastName, rutValue, checkbox, phoneValue, userInfo, birthDate} = StorageService.getSecureItem('register_prime_data');
        let _birthDay =  birthDate.replace(/\//g, '');
        _birthDay = _birthDay.slice(-4) + '-' + _birthDay.slice(2, 4)  + '-' + _birthDay.slice(0, 2);

        const formRegisterData = {
            'dateBirth': Day(_birthDay).format('YYYY-MM-DD'),
            'firstName': firstName,
            'lastName': lastName,
            'dni': formatRut(rutValue).replaceAll("." ,""),
            'cardBin': card.lastDigits,
            'cardToken': card.token,
            'cardBrand': card.brand,
            'accepts': checkbox,
            'phone': phoneValue,
        }

        return PrimeService.register(formRegisterData)
            .then(response => {
                if(response.statusCode === 200) {
                    const body = {};
                    if(!userInfo.document) {
                        body.document = rutValue.replace('-', '');
                    }
                    if(!userInfo.homePhone || phoneValue !== userInfo.homePhone) {
                        body.homePhone = phoneValue;
                    }
                    if(!userInfo.birthDate || userInfo.birthDate !== birthDate) {
                        body.birthDate = Day(_birthDay).format('YYYY-MM-DD')
                    }
                    if(Object.keys(body).length) {
                        return UserInfoService.updateUser(body).then(() => {
                            return _successRegister(body)
                        })
                    } else {
                        return _successRegister()
                    }
                }
                return response
            })
    }

    useEffect(() => {
        actions.push(PubSub.register(actionsType.DRAWER.PAYMENT_METHOD_PRIME_OPEN, _open))

        let dataStorage = StorageService.getSecureItem('open_drawer_prime')

        if (dataStorage) {
            if(dataStorage.updatePayment){
                dataStorage.callbackSuccess = callbackSuccessUpdate;
            }
            if(dataStorage.renovation){
                dataStorage.callbackSuccess = callbackSuccessRenovation;
            }
            if(dataStorage.register){
                dataStorage.callbackGoBack = callbackGoBackRegister;
                dataStorage.callbackSuccess = callbackSuccessRegister;
            }

            PubSub.dispatch(actionsType.DRAWER.PAYMENT_METHOD_PRIME_OPEN, { ...dataStorage, init: true, change: false })
            StorageService.removeSecureItem('open_drawer_prime')
        }

        return function cleanup() {
            actions.map((token) => PubSub.unregister(token))
            actions = []
        }
    }, [])

    const _open = (_payload) => {
        setPayload(_payload)
    }

    return (
        <Drawer
            customClass='drawer-payment-method-prime'
            actionOpen={actionsType.DRAWER.PAYMENT_METHOD_PRIME_OPEN}
            actionClose={actionsType.DRAWER.PAYMENT_METHOD_PRIME_CLOSE}>
            {payload && <PaymentMethodPrime payload={payload} />}
        </Drawer>
    )
}

export default DrawerPaymentMethodPrime
